import React, {useState} from 'react';
import PropTypes from 'prop-types';

const Button = ({color, onClick, text}) => {
    const [hover, setHover] = useState(false);

    const getBackgroundColor = () => {
        if (color === 'pink') {
            return hover ? '#C21D51' : '#E42461';
        } else {
            return hover ? '#1D7C70' : '#29A499';
        }
    };

    return (
        <div onClick={onClick}
             onMouseEnter={() => setHover(true)}
             onMouseLeave={() => setHover(false)}
             style={{
                 ...styles.container,
                 backgroundColor: getBackgroundColor(),
             }}>{text}
        </div>
    );
};

Button.propTypes = {
    color: PropTypes.oneOf(['pink', 'green']).isRequired,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
};

const styles = {
    container: {
        borderRadius: 8,
        color: '#ffffff',
        fontFamily: 'Ubuntu',
        fontSize: '23px',
        fontWeight: 500,
        padding: '25px',
        width: '100%',
        textAlign: 'center',
        marginBottom: '30px',
    },
}

export default Button;
